import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAllChampions, getDataDragonVersion } from '../lib/champions';
import { useApexTiers } from '../hooks/useApexTiers';
import { useData } from './DataContext';
import { log } from '../lib/logger';

/**
 * APEX v8.17 — SettingsContext
 *
 * Données de référence non-utilisateur (stables ou rarement changeantes) :
 *   - champions : liste des champions Data Dragon (avec icônes, splash, etc.)
 *   - version   : version DDragon courante (pour construire les URLs d'assets)
 *   - apexTiers : seuils Master/GM/Chall en LP par région (Edge Function)
 *
 * Le chargement se fait au mount (champions/version) et au changement de
 * région de l'utilisateur (apexTiers).
 *
 * Avantage : ces données peuvent être consommées partout sans props drilling
 * (utiles dans ChampIcon, OnboardingModal, ChampionPoolManager, etc.)
 */

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const { userSettings } = useData();
  const [champions, setChampions] = useState(null);
  const [version, setVersion] = useState(null);

  // V7.8.4 : seuils Master/GM/Chall LP temps réel via Edge Function
  const { tiers: apexTiers } = useApexTiers(userSettings?.riot_region || 'euw1');

  useEffect(() => {
    (async () => {
      try {
        const v = await getDataDragonVersion();
        const c = await getAllChampions();
        setVersion(v);
        setChampions(c);
      } catch (err) {
        log.error('[SettingsContext] Failed to load champions/version:', err);
      }
    })();
  }, []);

  return (
    <SettingsContext.Provider value={{ champions, version, apexTiers }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (ctx === null) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return ctx;
}
